<template>

    <div class="content">
        <loader></loader>
        <dynamic-link-payin v-if="checkLinkSubmenu('payin')"></dynamic-link-payin>
    </div>

</template>

<script>
    import DynamicLinkHeader from './DynamicLinkHeader';
    import DynamicLinkPayin from './DynamicLinkPayin';
    import DynamicLinkPayout from './DynamicLinkPayout';
    import Loader from "../Loader";

    export default {
        name: 'DynamicLink',
        components: { DynamicLinkPayin, Loader},

        methods: {
            checkLinkSubmenu(submenu) {
                return this.getLinkSubmenu === submenu;
            },
            getMerchant() {
                this.$store.commit('setLoading', 1);
                axios.get('/admin/merchant')
                    .then((response) => {
                        if (response.data.data !== null) {
                            this.$store.commit('setMerchant', response.data.data);
                        }
                        this.$store.commit('unsetLoading')
                    })
                    .catch(() => {
                        this.$store.commit('unsetLoading')
                    });
            }
        },

        computed: {
            getLinkSubmenu() {
                return this.$store.state.linkSubmenu;
            },
        },

        created() {
            this.getMerchant();
        }
    }
</script>

<style>

</style>